import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/projects/[slug]/ProjectDetailClient.tsx");
